import React, { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Axios from 'axios'
import K from '../services/k'
import '../custom.css'
import { Hidden, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import MenuIcon from '@material-ui/icons/Menu'
import DeliveryAutocomplete from '../components/mapdistance'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faMapMarkedAlt,
  faSignInAlt,
  faSignOutAlt,
  faUser,
  faUserCog,
  faSun,
  faMoon,
  faSearchLocation,
} from '@fortawesome/free-solid-svg-icons'
import Services from '../services/Services'

const useStyles = makeStyles(() => ({
  root: {},
  flexGrow: {
    flexGrow: 1,
  },
  iconButton: {
    padding: 0,
    '&:hover': {
      background: 'transparent',
    },
  },
}))

function Header(props) {
  const [bMaintenance, setbMaintenance] = React.useState(false)

  // menu and responsiveness on mobile
  const [activeMenu, setActiveMenu] = useState(true)
  const [screenSize, setScreenSize] = useState(undefined)

  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth)

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (screenSize <= 800) {
      setActiveMenu(false)
    } else {
      setActiveMenu(true)
    }
  }, [screenSize])

  const authResponse = useSelector((state) => state.userAuth.authResponse)

  const classes = useStyles()

  const toggleTheme = () => {
    props.changeTheme('DARK' === theme ? 'LIGHT' : 'DARK')
  }

  const token = localStorage.getItem(['__react_session__'])
  const [jsontoken, setJsonToken] = React.useState(JSON.parse(token))

  const [client_id, setClientId] = React.useState(null)
  const [first_name, setFirstName] = React.useState('')
  const [last_name, setLastName] = React.useState('')
  const [user_email, setUserEmail] = React.useState('')
  const [phone_number, setPhoneNumber] = React.useState('')

  useEffect(() => {
    setJsonToken(JSON.parse(token))
  }, [token])

  useEffect(() => {
    if (jsontoken !== '' && jsontoken !== null) {
      setClientId(
        jsontoken.user_id !== '' ? ('00000' + jsontoken.user_id).slice(-5) : '',
      )
      setFirstName(jsontoken.first_name)
      setLastName(jsontoken.last_name)
      setUserEmail(jsontoken.email)
      setPhoneNumber(jsontoken.phone_numberZZ)
      // membership = jsontoken.membership;
    }
  }, [jsontoken])

  const [currentUser, setCurrentUser] = useState({})

  useEffect(() => {
    const services = new Services(this)
    services.fetchUser().then((data) => {
      if (data.resultcode === 1) {
        const user = data.user[0]
        setCurrentUser(user)
      }
    })
  }, [])

  useEffect(() => {
    if (authResponse !== '' && authResponse.success === true) {
      alert(authResponse.message)
      localStorage.removeItem('user-token')
    }
    return () => {}
  }, [authResponse])
  //allocate locations to state
  const [locations, setlocations] = useState([])
  const fetchlocations = async () => {
    var resp
    try {
      resp = await Axios.get(`${K.baseUrl}locations`)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (
      resp === undefined ||
      (resp && resp.message && resp.message.indexOf('log in') > -1)
    ) {
      props.logOut()
      return
    }
    setlocations(resp.data.locations)
  }
  useEffect(() => {
    fetchlocations()
  }, [])
  //set and get current location
  const [clocation, setclocation] = useState('0')

  const needAccountMenu = () => {
    return (
      window.location.href.indexOf('riderregistration') === -1 &&
      window.location.href.indexOf('verify') === -1 &&
      window.location.href.indexOf('success') === -1
    )
  }

  return (
    <>
      <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
        <header>
          <div className="container">
            <div className="row m-0">
              <div className="col-2 m-0 p-0">
                <div className="primary-logo">
                  <Link to="/">
                    <img
                      src={
                        theme && theme === 'DARK'
                          ? '/images/roadjockey-logo_dark.png'
                          : '/images/roadjockey-logo.png'
                      }
                      width="180"
                      alt="Logo"
                    />
                  </Link>
                </div>
              </div>
              <div className="col-1 m-0 p-0"></div>
              <div className="col-9 m-0 p-0">
                <div className="menu-block">
                  <div className="mobile-toggle">
                    <span></span>
                    <span></span>
                    <span></span>
                    <Hidden mdUp>
                      <IconButton
                        className={classes.iconButton + ' mb-3'}
                        onClick={() => setActiveMenu(!activeMenu)}
                        aria-label="Menu"
                      >
                        <MenuIcon />
                      </IconButton>
                    </Hidden>
                  </div>
                  {activeMenu && (
                    <nav>
                      <ul>
                        <li className="active">
                          <a
                            href="https://apps.apple.com/us/app/road-jockey/id1595594217?platform=iphone"
                            className="ml-4"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              className="m-0"
                              src="https://roadjockey.com/images/img-apple-btn.png"
                              style={{ height: '35px' }}
                            />
                          </a>
                          <a
                            href="https://play.google.com/store/search?q=road%20jockey%20llc&c=apps"
                            className="ml-4"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              className="m-0"
                              src="https://roadjockey.com/images/img-google-btn.png"
                              style={{ height: '35px' }}
                            />
                          </a>
                        </li>
                        <li>
                          {theme && (
                            <button
                              className={'btn_navbar_icon ml-5'}
                              onClick={toggleTheme}
                              aria-label="Theme"
                            >
                              {theme === 'DARK' && (
                                <FontAwesomeIcon icon={faSun} />
                              )}
                              {theme === 'LIGHT' && (
                                <FontAwesomeIcon icon={faMoon} />
                              )}
                            </button>
                          )}
                        </li>
                        {needAccountMenu() && (
                          <>
                            <li>
                              <button
                                className={'btn_navbar_icon ml-2'}
                                data-toggle="modal"
                                data-target="#searchPlacemodal"
                                id="open_place_modal"
                              >
                                <FontAwesomeIcon icon={faSearchLocation} />
                              </button>
                            </li>
                            <li className="active sign-in ">
                              {jsontoken !== null &&
                              jsontoken.api_token &&
                              jsontoken.api_token !== null &&
                              jsontoken.api_token !== '' ? (
                                <div className="active sign-in nav-item dropdown d-inline">
                                  <button
                                    to="#"
                                    className="dropdown-toggle btn_navbar_icon ml-2"
                                    id="navbarDropdown"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    <FontAwesomeIcon icon={faUser} />
                                  </button>

                                  <div
                                    className="dropdown-menu"
                                    aria-labelledby="navbarDropdown"
                                  >
                                    <span className="greetings">
                                      <strong>
                                        Hello,{' '}
                                        <span className="capitalize">
                                          {first_name} {last_name}
                                        </span>
                                      </strong>
                                    </span>
                                    <div className="dropdown-divider"></div>
                                    <p className=" dropdown-item-title">
                                      Balance:
                                      <br />
                                      <span>
                                        JMD $
                                        {currentUser &&
                                        currentUser.personal_balance > 0
                                          ? currentUser.personal_balance
                                          : 0}
                                      </span>
                                    </p>
                                    <p className=" dropdown-item-title">
                                      Locked Balance:
                                      <br />
                                      <span>
                                        JMD $
                                        {currentUser &&
                                        currentUser.locked_balance > 0
                                          ? currentUser.locked_balance
                                          : 0}
                                      </span>
                                    </p>
                                    <p className=" dropdown-item-title">
                                      Client ID:
                                      <br />
                                      <span>{client_id}</span>
                                    </p>
                                    <p className=" dropdown-item-title">
                                      Name:
                                      <br />
                                      <span>
                                        {first_name} {last_name}
                                      </span>
                                    </p>
                                    <p className=" dropdown-item-title">
                                      Email:
                                      <br />
                                      <span>{user_email}</span>
                                    </p>
                                    <div className="dropdown-divider"></div>
                                    <p className=" dropdown-item-title">
                                      Phone Number:
                                      <br />
                                      <span>{phone_number}</span>
                                    </p>
                                    <div className="dropdown-divider"></div>
                                    <Link
                                      to="/view-profile"
                                      className="dropdown-item dropdown-item-link"
                                    >
                                      <FontAwesomeIcon icon={faUserCog} /> My
                                      Account
                                    </Link>
                                    {/* <Link to="/view-profile">Welcome: {user_email}</Link> */}
                                    <a
                                      className="dropdown-item dropdown-item-link light-btn"
                                      onClick={props.logOut}
                                    >
                                      <FontAwesomeIcon icon={faSignOutAlt} />{' '}
                                      Log Out
                                    </a>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </li>

                            {jsontoken !== null &&
                            jsontoken.api_token &&
                            jsontoken.api_token !== null &&
                            jsontoken.api_token !== '' ? (
                              <></>
                            ) : (
                              <>
                                <li className="active sign-in nav-item dropdown">
                                  <button
                                    className="btn_navbar_icon dropdown-toggle"
                                    id="navbarDropdown"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    <FontAwesomeIcon icon={faSignInAlt} />
                                  </button>
                                  <div
                                    className="dropdown-menu"
                                    aria-labelledby="navbarDropdown"
                                  >
                                    {bMaintenance && (
                                      <div>
                                        During construction, our sign in is not
                                        available.
                                      </div>
                                    )}
                                    {!bMaintenance && (
                                      <div>
                                        <br />
                                        <span className="dropdown-item">
                                          <strong>
                                            Hi, welcome to Road Jockey
                                          </strong>
                                        </span>
                                        <div className="dropdown-divider"></div>
                                        <p className=" dropdown-item-title dark">
                                          Already have an account?
                                        </p>
                                        <Link
                                          to="/login"
                                          className="dropdown-item dropdown-item-link"
                                        >
                                          Log In
                                        </Link>
                                        <div className="dropdown-divider"></div>
                                        <p className=" dropdown-item-title dark">
                                          New to Road Jockey?
                                        </p>
                                        <Link
                                          to="/signup"
                                          className="dropdown-item dropdown-item-link light-btn"
                                        >
                                          Create Account
                                        </Link>
                                      </div>
                                    )}
                                  </div>
                                </li>
                              </>
                            )}
                          </>
                        )}
                      </ul>
                    </nav>
                  )}
                </div>
              </div>
            </div>
          </div>
        </header>
        <div
          className="modal fade"
          id="searchPlacemodal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div>
                  <h3 className="modal-title" id="exampleModalLabel">
                    Search Delivery Address
                    <br></br>
                  </h3>
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <FontAwesomeIcon
                    style={{
                      position: 'absolute',
                      margin: '14px 15px',
                      color: '#42B749',
                    }}
                    icon={faMapMarkedAlt}
                  />
                  <DeliveryAutocomplete></DeliveryAutocomplete>
                </div>
              </div>
              <div className="modal-footer">
                <a href="/restaurants">
                  <button type="button" className="primary-btn">
                    Select
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header
